import { z } from 'zod';

export const englishIqSkillV2Schema = z.enum(['grammar', 'meaning', 'listening']);

export type EnglishIqSkillV2Type = z.infer<typeof englishIqSkillV2Schema>;
